import api, {ApiResponse} from "./index";

export interface UserProfile {
  userid: number,
  unionid?: string,
  username: string,
  idcard_type?: string,
  idcard?: string,
  mobile: string,
  area_id?: string,
  head_img_url?: string,
  photo?: string,
  company?: string,
  dept?: string,
  job_title?: string,
  professional_title?: string,
  sex?: string,
  edu?: string,
  health?: string,
}

export interface LoginPayload {
  mobile: string,
  code: string,
}
export type LoginResponse = {
  sessionid: string,
}

interface SessionRequest<T = ApiResponse> {
  login(payload: LoginPayload): Promise<ApiResponse<LoginResponse>>,
  logout(): Promise<T>,
  getProfile(): Promise<ApiResponse<UserProfile>>,
}
const sessionApi: SessionRequest = {
  login(payload) {
    return api.post('/api/sskt/login.do', { ...payload })
  },
  logout() {
    return api.post('/api/v1/game/user/logout.xhtml')
  },
  getProfile() {
    return api.post('/api/v1/game/user/userinfo.xhtml')
  },
}

export default sessionApi